export enum Betriebsart {
  TK = 'TK',
  KUEHLSCHRANK = 'KUEHLSCHRANK',
  ZIMMERTEMPERATUR = 'ZIMMERTEMPERATUR',
  HITZE_NIEDRIG = 'HITZE_NIEDRIG',
  HITZE_MITTEL = 'HITZE_MITTEL',
  OBER_UNTER = 'OBER_UNTER',
  UMLUFT = 'UMLUFT'
}
